import React, { useState, useEffect } from 'react';
import config from "config";
import Spinner from 'NOTICEBOARD/CommonResources/SpinnerLoader/Spinner';
import NoticeboardAPICall from 'NoticeboardAPICall';
import { CalendarTodayOutlined, KeyboardArrowDownOutlined, Bookmark, SummarizeOutlined, Workspaces, GridViewOutlined, AttachFileOutlined, CheckOutlined, ShareOutlined, VisibilityOutlined, FiberManualRecord, FormatListBulletedOutlined, AccessTimeOutlined, WindowOutlined, Calculate } from '@mui/icons-material';
import Avatar from '@mui/material/Avatar';
import Popover from '@mui/material/Popover';
import { LinkOutlined, Instagram, Twitter, Telegram, FacebookOutlined, History, Close, ArrowBack } from '@mui/icons-material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import 'NOTICEBOARD/Components/NoticeboardDashbard/NoticeboardDashbard.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Pagination } from '@mui/material';
import StudentNoticeView from 'NOTICEBOARD/Components/StudentNoticeDashboard/StudentNoticeView';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import SuccessModal from 'NOTICEBOARD/CommonResources/SuccessModal/SuccessModal';
import dummyNoticeImage from 'NOTICEBOARD/Components/StudentNoticeDashboard/Image/dummyNoticeImage.png';
import Snackbar from '@mui/material/Snackbar';
import ButtonLoader from 'NOTICEBOARD/CommonResources/ButtonLoader/ButtonLoader';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import 'NOTICEBOARD/Components/StudentNoticeDashboard/studentdashboard.css';
import ReactHtmlParser from 'react-html-parser';


function StudentNoticeDashboard() {
    // api path
    let apiPathGetNoticeList = '/api/notice/notice.php'
    let apiPathGetIndividualNoticeDetails = '/api/notice/notice.php'

    // css styling
    let styles = {
        iconStyle: {
            color: '#828282',
            fontSize: '20px',
            marginRight: "5px",
        },

        dotIconStyle: {
            color: '#BDBDBD',
            fontSize: '10px',
            marginLeft: '5px'
        },

        bookmarkChecked: {
            color: '#FF9900'
        },

        bookmarkUnchecked: {
            color: '#828282',
        },

        bookMarkStatusCheck: {
            color: '#FF9900'
        },

        bookMarkStatusUncheck: {
            color: '#828282'
        },

        unreadNoticeUnchecked: {
            color: '#828282',
        },

        unreadNoticeChecked: {
            color: '#0465AC'
        },

        buttonDivStyle: {
            color: '#828282',
            fontSize: '12px',
            marginRight: '5px',
            padding: '5px',
            textAlign: 'center',
            background: 'white',
            cursor: 'pointer',
        },

        activeButtonDivStyle: {
            color: 'white',
            backgroundColor: '#0465AC',
            fontSize: '12px',
            marginRight: '5px',
            padding: '5px',
            textAlign: 'center',
            cursor: 'pointer',
        },

        popoverTextTitle: {
            width: '37%',
            borderRadius: '5px',
            padding: '2px',
            fontSize: 'small',
            color: 'rgba(0, 0, 0, 0.8)',
        },

        popoverInput: {
            border: '1px solid rgba(4, 101, 172, 0.7)',
            padding: '2px',
            fontSize: '12px',
            color: 'rgba(0, 0, 0, 0.4)',
        }
    }

    const [totalCount, setTotalCount] = useState(0);
    const [getIndividualNoticeDetails, setGetIndividualNoticeDetails] = useState({});
    const [dataFetchingGetIndividualNoticeDetails, setIndividualNoticeFetching] = useState(false);

    // popover for select date
    const [anchorEl, setAnchorEl] = React.useState(null);

    // METHOD FOR SEARCH CATEGORY 
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    //popover for select category
    const [anchorElCategory, setAnchorElCategory] = React.useState(null);

    // METHOD FOR SEARCH CATEGORY 
    const handleClickCategory = (event) => {
        setAnchorElCategory(event.currentTarget);
    };

    // METHOD FOR CLOSE SEARCH CATEGORY MODAL
    const handleCloseCategoryModal = () => {
        setAnchorElCategory(null);
    };

    // METHOD FOR CLEAR SEARCH CATEGORY 
    const handleCloseCategory = () => {
        setIsCategorySelected(false);
        setFilterNoticeCategory('');
        setAnchorElCategory(null);
        setNoticeList({});
        setNoticePagination({
            pageIndex: 1,
            limit: 20
        });
    };

    const openCategory = Boolean(anchorElCategory);
    const idCategory = openCategory ? 'simple-popover' : undefined;

    // states for noticelist
    const [noticeList, setNoticeList] = useState({});
    const [noticeSequence, setNoticeSequence] = useState([]);
    const [noticeTitle, setNoticeTitle] = useState('');
    const [filterApplied, setFilterApplied] = useState(false);
    const [filterDayType, setFilterDays] = useState('');
    const [filterFromDate, setFilterFormDate] = useState('');
    const [filterToDate, setFilterEndDate] = useState('');
    const [filterTitle, setFilterNoticeTitle] = useState('');
    const [filterCategory, setFilterNoticeCategory] = useState('');
    const [filterBookmark, setFilterNoticeBookmark] = useState(false);
    const [filterUnread, setFilterUnreadNotice] = useState(false);
    const [pageIndex, setPageIndex] = useState(1);
    const [noticeLimit, setNoticeLimit] = useState(20);
    const [noticePagination, setNoticePagination] = useState({
        pageIndex: 1,
        limit: 20
    });

    const [showSideBarNoticeView, setShowSideBarNoticeView] = useState(false);
    const [noticeViewObject, setNoticeViewObject] = useState({});

    const [successModalDetails, setSuccessModalDetails] = useState({
        successModal: false,
        successModalType: '',
        successMessage: ''
    });
    const [isCategorySelected, setIsCategorySelected] = useState(false);


    // METHOD FOR  GET NOTICE LIST API CALL 
    useEffect(() => {
        getNoticeList();
    }, [noticePagination]);

    // METHOD FOR FILTER NOTICES API CALL 
    useEffect(() => {
        getNoticeList();
    }, [filterDayType, filterBookmark, filterUnread]);

    // METHOD TO CLOSE SUCCESS MODAL
    const closeSuccessModal = () => {
        setSuccessModalDetails({
            successModal: false,
            successModalType: "",
            successMessage: ""
        });
    }

    //METHOD FOR LOAD MORE DATA
    const getNoticeListLoadMore = () => {
        setNoticePagination({
            pageIndex: noticePagination.pageIndex + 1,
            limit: 20
        });
    }

    // show side bar of notice view
    const showSideBarNoticeViewMethod = (noticeId, readStatus) => {
        apiCallToGetIndividualNotice(noticeId);
        if (readStatus == "false") {
            apiCallToUpdateNoticeUnread(noticeId);
        }

        setShowSideBarNoticeView(true);
    }


    // METHOD FOR BOOKMARK NOTICE
    const apiCallToChangeBookmarkStatus = async (noticeId, bookmarkStatus) => {
        let formData = {
            institute_id: config.institute_id,
            notice_id: noticeId,
            user_id: config.studentId,
            bookmark: (bookmarkStatus == 'true' ? 'false' : "true")

        };

        let jsonResponse = await NoticeboardAPICall.makeApiCall(
            "bookmarkNotice",
            formData,
            apiPathGetNoticeList
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                apiCallToChangeBookmarkStatus(noticeId, bookmarkStatus);
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;
                let noticeListDetails = noticeList;
                if (apiResult.status == "success") {
                    noticeListDetails[noticeId].bookmarkStatus = (bookmarkStatus == 'true' ? 'false' : "true");
                    toast(apiResult.message, {
                        position: "top-right",
                        autoClose: 4000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    setNoticeList({ ...noticeListDetails });
                } else {
                    toast(apiResult.message, {
                        position: "top-right",
                        autoClose: 4000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                }
            } else {
                toast("Something went wrong while changing bookmark status. Please try again later.", {
                    position: "top-right",
                    autoClose: 4000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
        }
    };

    // FUNCTION FOR GET INDIVIDUAL NOTICE DETAILS API CALL
    const apiCallToGetIndividualNotice = async (noticeId) => {
        setIndividualNoticeFetching(true);
        let formData = {
            institute_id: config.institute_id,
            notice_id: noticeId,
            user_id: config.studentId,
        };

        let jsonResponse = await NoticeboardAPICall.makeApiCall(
            "getIndividualNoticeDetails",
            formData,
            apiPathGetIndividualNoticeDetails
        );
        if (jsonResponse.expired) {
            setTimeout(() => {
                apiCallToGetIndividualNotice(noticeId);
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;

                setGetIndividualNoticeDetails(apiResult);
                setIndividualNoticeFetching(false);
            } else {
                setIndividualNoticeFetching(false);
            }
        }
    }

    // METHOD FOR BOOKMARK NOTICE
    const apiCallToUpdateNoticeUnread = async (noticeId, readStatus) => {
        let formData = {
            institute_id: config.institute_id,
            notice_id: noticeId,
            user_id: config.studentId,
        };

        let jsonResponse = await NoticeboardAPICall.makeApiCall(
            "updateNoticeReadStatus",
            formData,
            apiPathGetNoticeList
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                apiCallToUpdateNoticeUnread(noticeId, readStatus);
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;
                let noticeListDetails = noticeList;
                if (apiResult.status == "success") 
                {
                    noticeListDetails[noticeId].readStatus = "true";
                    toast(apiResult.message, {
                        position: "top-right",
                        autoClose: 4000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    setNoticeList({ ...noticeListDetails });
                } 
                else 
                {
                    toast(apiResult.message, {
                        position: "top-right",
                        autoClose: 4000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                }
            } 
            else {
                toast("Something went wrong while changing bookmark status. Please try again later.", {
                    position: "top-right",
                    autoClose: 4000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
        }
    };

    // METHOD FOR GET NOTICE LIST API CALL
    const getNoticeList = async () => {
        if (Object.keys(noticeList).length == 0) {
            setDataFetching(true);
        }

        let formData = {
            institute_id: config.institute_id,
            user_id: config.studentId,
            page_index: noticePagination.pageIndex,
            limit: noticePagination.limit,
            filter_title: filterTitle,
            filter_category: filterCategory,
            filter_from_date: filterFromDate,
            filter_to_date: filterToDate,
            filter_unread: filterUnread,
            filter_bookmark: filterBookmark,
            filter_day_type: filterDayType,
            filter_added_by: '',
            user_role: 'student'
        };

        let jsonResponse = await NoticeboardAPICall.makeApiCall(
            "getNoticeList",
            formData,
            apiPathGetNoticeList
        );
        if (jsonResponse.expired) {
            setTimeout(() => {
                getNoticeList();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;
                setTotalCount(jsonResponse.APIResult.totalCount);
                setNoticeList({ ...noticeList, ...apiResult });
                setNoticeSequence([ ...noticeSequence, ...jsonResponse.APIResult.sequenceIdArray ]);
                setDataFetching(false);
            } else {
                setDataFetching(false);
            }
        }
    };

    // METHOD FOR FILTER SEARCH BY DAYS
    const searchByDays = (type) => {
        setNoticeSequence([]);
        setNoticeList({});
        setFilterDays(type);
        setFilterApplied(true);
    }

    // METHOD FOR BOOKMARK NOTICE
    const bookmarkNotice = (noticeId, bookmarkStatus) => {
        apiCallToChangeBookmarkStatus(noticeId, bookmarkStatus);
    }

    // METHOD FOR SEARCH NOTICE BY TITLE
    const searchByTitle = (e) => {
        //  setNoticeTitleToSearch(noticeTitle)
        setNoticeSequence([]);
        setNoticeList({});
        getNoticeList();
    }

    // METHOD FOR SEARCH NOTICE DATE   
    const searchByDate = (e) => {
        setNoticeSequence([]);
        setNoticeList({});
        setNoticePagination({
            pageIndex: 1,
            limit: 20
        });
        setFilterApplied(true);
        handleClose();
    }

    // METHOD FOR SEARCH NOTICE BY CATEGORY   
    const searchByCategory = (e) => {
        if (filterCategory) 
        {
            setIsCategorySelected(true);
        }
        else {
            setIsCategorySelected(false);
        }
        setNoticeList({});
        setNoticeSequence([]);
        setFilterApplied(true);
        setNoticePagination({
            pageIndex: 1,
            limit: 20
        });
        setAnchorElCategory(null);

    }

    // METHOD TO SEARCH BY BOOKMARK NOTICE
    const searchByBookmarkNotice = (e) => {
        // SetBookMarkNotice(!bookMarkNotice);
        setNoticeSequence([]);
        setNoticeList({});
        setFilterApplied(true);
        setFilterNoticeBookmark(!filterBookmark);
    }

    // METHOD FOR SEARCH BY UNREAD NOTICE 
    const searchByUnreadNotice = (e) => {
        setNoticeSequence([]);
        setNoticeList({});
        setFilterApplied(true);
        setFilterUnreadNotice(!filterUnread);

    }
    // METHOD TO CLEAR FILTER NOTICE
    const closeFilterNotice = () => {
        setFilterNoticeCategory('')
        setFilterNoticeTitle('')
        setFilterDays('');
        setFilterFormDate('');
        setFilterEndDate('');
        setFilterFormDate('');
        setFilterUnreadNotice(false);
        setFilterNoticeBookmark(false);
        setIsCategorySelected(false);
        setNoticeList({});
        setFilterApplied(true);
        setNoticePagination({
            pageIndex: 1,
            limit: 20
        });
    }
    
    // state for search by category
    const [showModalReadUnreadStatus, setShowModalReadUnreadStatus] = useState(false)
    const [showModalHistory, setShowModalHistory] = useState(false)
    const [showShareModal, setShowShareModal] = useState(false)
    
    const [deviceWidth, setDeviceWidth] = useState('');
    const [isGrid, setIsGrid] = useState(true);
    useEffect(() => {
        setDeviceWidth(window.innerWidth)
    }, [deviceWidth])
    
    let apiPathCategoryList = "/api/notice/category.php";
    const [dataFetching, setDataFetching] = useState(false);
    const [categoryList, setCategoryList] = useState({});
    const [offset, setOffset] = useState(0);
    const [activePage, setActivePage] = useState(1);
    const [limit, setLimit] = useState(100);
    const [searchCategory, setSearchCategory] = useState('');
    
    // calling CategoryListAPI to get category
    useEffect(() => {
        getCategoryListAPICall();
    }, [offset, activePage, limit])
    
    // calling CategoryListAPI to get category
    useEffect(() => {
        getCategoryListAPICall();
    }, [searchCategory]);
    // METHOD TO GET CATEGORY LIST API CALL    
    const getCategoryListAPICall = async () => {
        // setDataFetching(true);

        let formData = {
            "iid": config.institute_id,
            "offset": '',
            "limit": '',
            "filterCategoryName": searchCategory,
            "filterStatus": ""
        }
        let jsonResponse = await NoticeboardAPICall.makeApiCall(
            'GetNoticeBoardCategoryList',
            formData,
            apiPathCategoryList
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                getCategoryListAPICall();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;
                setCategoryList(apiResult);
                setDataFetching(false);
            } else {
                setDataFetching(false);
                // setSuccessModalDetails({
                //     successModal:true,
                //     successModalType:"error",
                //     successMessage:"Something went wrong while getting category list. Please try again later."
                // });
            }
        }

    }

    // METHOD FOR SEARCH BY NOTICE TITLE 
    const setFilterVariables = () => {
        setNoticeSequence([]);
        setNoticeList({});
        setNoticePagination({
            pageIndex: 1,
            limit: 20
        });
    }
    // METHOD FOR SEARCH CATEGORY
    const searchCategoryFromAllCategory = (e) => {
        setSearchCategory(e.target.value);
        // getCategoryListAPICall();
    }
    const stripHtmlEntities = (text) => 
    {
        return text.replace(/<[^>]*>?/gm, '');
    }

    return (
        <>
            <div>
                {/* popover for select date */}
                <div className='col-md-12 pb-2 pt-2' style={{ backgroundColor: '#F4F4F4' }}>
                    <h3>Notices</h3>
                </div>
                <Popover
                    id={id}
                    open={open}
                    anchorEl={anchorEl}
                    onClose={handleClose}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                >
                    <div className='p-2' style={{ height: '80px', width: '350px' }}>

                        <div className="row">
                            <div style={styles.popoverTextTitle}>From</div>
                            <div style={styles.popoverTextTitle}>To</div>
                            <div ></div>
                            <div style={styles.popoverTextTitle}>
                                <input
                                value={filterFromDate}
                                onChange={(e) => { setFilterFormDate(e.target.value) }}
                                type="date" 
                                style={styles.popoverInput} 
                                className='w-100 rounded' 
                                />
                            </div>
                            <div style={styles.popoverTextTitle}>
                                <input
                                value={filterToDate}
                                min={filterFromDate}
                                onChange={(e) => { setFilterEndDate(e.target.value)}}
                                type="date" 
                                style={styles.popoverInput} 
                                className='w-100 rounded' 
                                />
                            </div>
                            <div >
                                <button onClick={() => searchByDate()}
                                type="button" className="my-0 smallNormalFont py-1 shadow-none btn btn-primary">Apply</button>
                            </div>
                        </div>
                    </div>
                </Popover>

                {/* popover for category */}
                <Popover
                    id={idCategory}
                    open={openCategory}
                    anchorEl={anchorElCategory}
                    onClose={handleCloseCategoryModal}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                >
                    <div className='p-2' style={{ height: '190px', maxWidth: '500px' }} >
                        <div className='scrollController' style={{ height: '80%' }}>
                            <div className='row'><div className='col-12'>
                                <input className='w-100 searchCategoryInput '
                                    placeholder='Search category...' value={ searchCategory }
                                    onKeyPress={ e => {
                                        if (e.charCode === 13) {
                                            searchCategoryFromAllCategory(e);
                                        }
                                    } }
                                    onChange={ (e) => setSearchCategory(e.target.value) } />
                            </div></div>
                            <div className='row' style={{ fontSize: '13px' }}>
                                {
                                    categoryList &&
                                    Object.keys(categoryList).map(categoryId => {
                                        return (
                                            <div className='col-6 form-check text-left my-1 categoryName-filter' title={categoryList[categoryId].title} key={categoryId}>
                                                <input
                                                    onChange={() => setFilterNoticeCategory(categoryId)}
                                                    className="form-check-input"
                                                    name="flexRadioDefault"
                                                    type="radio"
                                                    id="flexCheckDefault"
                                                    checked={categoryId == filterCategory ? true : false}
                                                />
                                                <span className='smallFont secondaryColor'>{categoryList[categoryId].title}</span>
                                            </div>
                                        );
                                    })
                                }
                            </div>
                        </div>
                        <div className="d-flex justify-content-end " style={{ height: '20%' }}>
                            <button
                                onClick={() => searchByCategory()}
                                type="button" className="py-1 my-1 smallFont  shadow-none btn btn-primary">Apply</button>
                            <button type="button" onClick={handleCloseCategory} className="py-1 my-1 smallFont btn shadow-none border border-primary text-primary">Clear</button>
                        </div>
                    </div>
                </Popover>
            </div>
            <div className='backgroundColor studentDashboardContainer'>
                <div className='d-flex col-md-12' >
                    <div className='smallFont secondaryColor flex-grow-1'>
                        <div className="noticeDashboardContainer">
                            <div className='p-0 mx-md-1 '>
                                <input className='w-100 '
                                    style={{ padding: '3px', border: '0.2px solid #BDBDBD', marginRight: "15px" }}
                                    placeholder='Search By Title...' value={filterTitle}
                                    onKeyPress={event => {
                                        if (event.charCode === 13) {
                                            setFilterVariables();
                                        }
                                    }}
                                    onChange={(e) => setFilterNoticeTitle(e.target.value)} />
                            </div>

                            <div className='col-md-3 col-sm-12 p-0 py-2 ml-20 '>
                                <div className='filterByDays'  >
                                    <div
                                        onClick={() => filterDayType == 'today' ? searchByDays('') : searchByDays('today')} className='w-100' style={filterDayType === 'today' ? styles.activeButtonDivStyle : styles.buttonDivStyle} >Today</div>
                                    <div
                                        onClick={() => filterDayType == 'week' ? searchByDays('') : searchByDays('week')} className='w-100' style={filterDayType === 'week' ? styles.activeButtonDivStyle : styles.buttonDivStyle} >This Week</div>
                                    <div
                                        onClick={() => filterDayType == 'month' ? searchByDays('') : searchByDays('month')} className='w-100' style={filterDayType === 'month' ? styles.activeButtonDivStyle : styles.buttonDivStyle} >This Month</div>
                                </div>
                            </div>

                            <div className='p-0 py-2'>
                                <div onClick={handleClick} className='pointer' >Select Date<CalendarTodayOutlined style={styles.iconStyle} className='mx-2' /></div>
                            </div>

                            <div onClick={handleClickCategory} className='p-0'>
                                <div className='d-flex justify-content-between align-items-center  p-1 bg-white'>
                                    <div className='pointer'>Search By Category</div>
                                    <KeyboardArrowDownOutlined className='mx-1' />
                                </div>
                            </div>

                            <div className='p-0 py-2'>
                                <div className='d-flex justify-content-between p-0'>
                                    <div className=' pointer' style={filterUnread ? styles.unreadNoticeChecked : styles.unreadNoticeUnchecked} onClick={(e) => searchByUnreadNotice(e)}><SummarizeOutlined />Unread Notices</div>
                                    <div className='pointer' onClick={(e) => searchByBookmarkNotice(e)}><Bookmark style={filterBookmark ? styles.bookmarkChecked : styles.bookmarkUnchecked} />Bookmarked Notices</div>
                                    <button className="clear" onClick={() => closeFilterNotice()} >Clear</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    {deviceWidth > 767 && <div className='p-2 pointer'>{isGrid ? <FormatListBulletedOutlined onClick={() => setIsGrid(!isGrid)} style={styles.iconStyle} /> : <WindowOutlined onClick={() => setIsGrid(!isGrid)} style={styles.iconStyle} />}</div>}
                </div>
                {
                    dataFetching ?
                        <Spinner />
                    :
                        <>
                            {
                                isGrid === true ?
                                    <div className='row col-md-12'>
                                        {
                                            Object.keys(noticeList).length > 0 ?
                                                noticeSequence.map((noticeId, noticeIndex) => {
                                                    let notice = noticeList[noticeId];
                                                    let noticeAttachments = notice.attachment == '' ? [] : notice.attachment.split(',');
                                                    let description =  ReactHtmlParser(notice.description);
                                                    let newString = stripHtmlEntities(notice.description)


                                                    return (
                                                        <div className='col-md-6 col-sm-12  px-1 my-1  noticeCard '>
                                                            {
                                                                deviceWidth > 767 ?
                                                                    <div className="row bg-white  col-md 12 p-2">
                                                                        <div className='col-2 col-2 border p-0' style={{ height: 120 }}>
                                                                            {
                                                                                noticeAttachments.length > 0 ?
                                                                                    <>
                                                                                        {
                                                                                            (noticeAttachments[0].substring(noticeAttachments[0].lastIndexOf('.') + 1) === 'pdf') ?
                                                                                                <img src={dummyNoticeImage} height='100%' width='100%' />
                                                                                            :
                                                                                                <img src={notice.attachmentPath + noticeAttachments[0]} height='100%' width='100%' />
                                                                                        }
                                                                                    </>
                                                                                :
                                                                                    <img src={dummyNoticeImage} height='100%' width='100%' />
                                                                            }
                                                                        </div>
                                                                        <div className='col-9 smallFont'>
                                                                            <div className="w-100">
                                                                                <p style={{ fontSize: '14px', color: '#0465AC', fontWeight: 'bold', cursor: "pointer" }} onClick={() => showSideBarNoticeViewMethod(notice.noticeId, notice.readStatus)} title={notice.title}>
                                                                                    {notice.title.length > 50 ? notice.title.substring(0, 50) + "..." : notice.title}
                                                                                </p>
                                                                                <div className='my-1 d-flex justify-content-between align-items-center' >
                                                                                    <div style={{ width: '90%' }} className='text-truncate ' title={newString}>{description}</div>
                                                                                    <div style={{ fontSize: '14px' }}><AttachFileOutlined style={{ fontSize: '18px' }} />{noticeAttachments.length}</div>
                                                                                </div>
                                                                                <div className='w-100 d-flex'>
                                                                                    <div style={{ width: '50%', cursor: "pointer" }} title={notice.categoryName} className='text-truncate primaryColor mr-2' onClick={() => setFilterNoticeCategory(notice.categoryId)}><Workspaces style={{ fontSize: '16px', color: '#BDBDBD', marginRight: '10px' }} />{notice.categoryName}</div>
                                                                                    <div className='text-truncate'>
                                                                                        {
                                                                                            notice.department &&
                                                                                                notice.department.split(',').map(department => {
                                                                                                    return (
                                                                                                        <>
                                                                                                            <FiberManualRecord style={styles.dotIconStyle} /> {department}
                                                                                                        </>
                                                                                                    );
                                                                                                })
                                                                                        }
                                                                                    </div>
                                                                                </div>
                                                                                <div className='my-1 d-flex justify-content-between align-items-center' >
                                                                                    {
                                                                                        typeof notice.addedBy == 'string' &&
                                                                                            <div className='MemberIcon'>
                                                                                                {
                                                                                                    notice.addedBy.split(' ')[0].charAt(0) + notice.addedBy.split(' ')[1].charAt(0)
                                                                                                }
                                                                                            </div>
                                                                                    }
                                                                                    <div className='noticeMember' >By {notice.addedBy}</div>
                                                                                    <div>
                                                                                        <AccessTimeOutlined style={styles.iconStyle} className='mx-1' />
                                                                                        <span style={{ borderBottom: '1px dashed blue' }}>{notice.formattedNoticeDate}</span>
                                                                                    </div>
                                                                                    {/* <div className='pointer' onClick={ () => setShowModalReadUnreadStatus(true) }><VisibilityOutlined className='mx-1 primaryColor' />{ notice.assigneeCount }</div>
                                                                                    <div className="iconBg">
                                                                                        <ShareOutlined onClick={ () => setShowShareModal(true) } className='pointer' style={ styles.iconStyle } />
                                                                                    </div> */}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-1">
                                                                            <div className='h-100 d-flex justify-content-between align-items-center flex-column'>
                                                                                <Bookmark className='bookMark' style={notice.bookmarkStatus == 'true' ? styles.bookMarkStatusCheck : styles.bookMarkStatusUncheck} onClick={() => bookmarkNotice(notice.noticeId, notice.bookmarkStatus)} />
                                                                                {
                                                                                    notice.readStatus == "true" ?
                                                                                        <DoneAllIcon style={notice.readStatus ? styles.unreadNoticeChecked : styles.unreadNoticeUnchecked} />
                                                                                        :
                                                                                        <CheckOutlined style={notice.readStatus ? styles.unreadNoticeUnchecked : styles.unreadNoticeUnchecked} />
                                                                                }
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                :
                                                                    <div className='row bg-white smallFont secondaryColor'>
                                                                        <div className='col-2 border' style={{ height: '80px' }}>{noticeIndex}</div>
                                                                        <div className='col-10  px-2'>
                                                                            <div className='d-flex'>
                                                                                <div className='flex-grow-1' style={{ fontSize: '14px', color: '#0465AC', fontWeight: 'bold' }}>{notice.title}</div>
                                                                                <div >
                                                                                    <Bookmark style={notice.bookmarkStatus == 'true' ? styles.bookMarkStatusCheck : styles.bookMarkStatusUncheck} className='mx-2' />
                                                                                    {
                                                                                        notice.readStatus == "true"
                                                                                            ? <DoneAllIcon style={notice.readStatus ? styles.unreadNoticeChecked : styles.unreadNoticeUnchecked} />

                                                                                            : <CheckOutlined style={notice.readStatus ? styles.unreadNoticeUnchecked : styles.unreadNoticeUnchecked} />
                                                                                    }
                                                                                </div>
                                                                            </div>
                                                                            <div className='row'>
                                                                                <div className='text-truncate p-0 col-10'>{notice.description.length > 50 ? `${notice.description.substring(0, 50)}...` : notice.description}</div>
                                                                                <div style={{ fontSize: '14px' }} className='col-2 p-0'><AttachFileOutlined style={{ fontSize: '18px' }} />{notice.attachment != "" ? 1 : 0}</div>
                                                                            </div>
                                                                            <div className='col-12 p-0'>
                                                                                <div className='primaryColor mr-2'><Workspaces style={{ fontSize: '16px', color: '#BDBDBD', marginRight: '10px' }} />Extra Curricular</div>
                                                                            </div>
                                                                            <div className='col-12 d-flex p-0'>
                                                                                <div className='text-truncate p-0 col-10'>
                                                                                    {
                                                                                        notice.department &&
                                                                                        notice.department.split(',').map(department => {
                                                                                            return (
                                                                                                <>
                                                                                                    <FiberManualRecord style={styles.dotIconStyle} /> {department}
                                                                                                </>
                                                                                            );
                                                                                        })
                                                                                    }
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className='col-12 px-1'>
                                                                            <div className='my-1 d-flex justify-content-between align-items-center' >
                                                                                <div className='MemberIcon'>
                                                                                    {notice.addedBy.split(' ')[0].charAt(0) + notice.addedBy.split(' ')[1].charAt(0)}
                                                                                </div>
                                                                                <div className='noticeMember'>By {notice.addedBy}</div>
                                                                                <div><AccessTimeOutlined style={styles.iconStyle} className='mx-1' />
                                                                                    <span style={{ borderBottom: '1px dashed blue' }}>{notice.formattedNoticeDate}</span>
                                                                                </div>
                                                                                <div onClick={() => setShowModalReadUnreadStatus(true)}><VisibilityOutlined className=' mx-1 primaryColor' />{notice.assigneeCount}</div>
                                                                                {/* <div className="iconBg pointer">
                                                                                    <ShareOutlined onClick={() => setShowShareModal(true)} style={styles.iconStyle} />
                                                                                </div> */}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                            }
                                                        </div>
                                                    );
                                                })
                                            :
                                                filterApplied ? 
                                                    <div style={ { marginLeft: 14 } }>No notice details found as per applied filter.</div>
                                                :
                                                    <div style={ { marginLeft: 14 } }>No notice yet assigned. Please contact administrator for more details.</div>
                                        }
                                    </div>
                                :
                                    <div className='col-md-12 pt-2 pb-2'>
                                        {
                                            noticeList &&
                                                Object.keys(noticeList).length !== 0 ?
                                                    noticeSequence.map((noticeId, noticeIndex) => {
                                                        let notice = noticeList[noticeId];
                                                        let noticeAttachments = notice.attachment == '' ? [] : notice.attachment.split(',');
                                                        let description =  ReactHtmlParser(notice.description);
                                                        let newString = stripHtmlEntities(notice.description)


                                                        return (
                                                            <div className="d-flex justify-content-between p-2 mb-2 smallFont   bg-white">
                                                                <div>
                                                                    <div style={{ height: '50px', width: '50px', }} className='border'>
                                                                        <div style={{ height: '100%', width: '100%', }}>
                                                                            {
                                                                                noticeAttachments.length > 0 ?
                                                                                    <>
                                                                                        {
                                                                                            (noticeAttachments[0].substring(noticeAttachments[0].lastIndexOf('.') + 1) === 'pdf') ?
                                                                                                <img src={dummyNoticeImage} height='100%' width='100%' />
                                                                                            :
                                                                                                <img src={notice.attachmentPath + noticeAttachments[0]} height='100%' width='100%' />
                                                                                        }
                                                                                    </>
                                                                                :
                                                                                    <img src={dummyNoticeImage} height='100%' width='100%' />
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div style={{ width: '30%' }} className='d-flex flex-column justify-content-center'>
                                                                    <div className='text-truncate primaryColor boldFont' style={{ cursor: "pointer", fontWeight: 'bold' }}
                                                                        onClick={() => showSideBarNoticeViewMethod(notice.noticeId, notice.readStatus)}
                                                                        title={notice.title} >{notice.title.length > 50 ? `${notice.title.substring(0, 50)}...` : notice.title}</div>
                                                                    <div className='text-truncate' title={newString}>{description.length > 50 ? `${description.substring(0, 50)}...` : description}</div>
                                                                </div>
                                                                <div className='d-flex align-items-center'>
                                                                    <AttachFileOutlined style={{ fontSize: '18px' }} />
                                                                    <div style={{ fontSize: '14px' }}>{notice.attachment != "" ? 1 : 0}</div>
                                                                </div>
                                                                <div style={{ width: '30%' }} className='d-flex flex-column'>
                                                                    <div className='primaryColor pointer' title={notice.categoryName} style={{ textOverflow: 'ellipsis', overflow: 'hidden' }} onClick={() => setFilterNoticeCategory(notice.categoryId)}><Workspaces style={{ fontSize: '16px', color: '#BDBDBD', marginRight: '10px', }} />{notice.categoryName}</div>
                                                                    <div className='text-truncate'>
                                                                        {
                                                                            notice.department &&
                                                                                notice.department.split(',').map(department => {
                                                                                    return (
                                                                                        <>
                                                                                            <FiberManualRecord style={styles.dotIconStyle} /> {department}
                                                                                        </>
                                                                                    );
                                                                                })
                                                                        }
                                                                    </div>
                                                                </div>
                                                                <div className='d-flex justify-content-center align-items-center'>
                                                                    {
                                                                        typeof notice.addedBy == 'string' &&
                                                                            <div className='MemberIcon'>
                                                                                {
                                                                                    notice.addedBy.split(' ')[0].charAt(0) + notice.addedBy.split(' ')[1].charAt(0)
                                                                                }
                                                                            </div>
                                                                    }
                                                                    <div className='d-flex flex-column mx-2'>
                                                                        <div className='noticeMember'>By {notice.addedBy} </div>
                                                                        <div>
                                                                            <AccessTimeOutlined style={styles.iconStyle} />
                                                                            <span style={{ borderBottom: '1px dashed blue' }}>{notice.formattedNoticeDate}</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                {/* <div className="d-flex justify-content-center align-items-center">
                                                                        <ShareOutlined style={styles.iconStyle} />
                                                                    </div> */}
                                                                <div className="d-flex justify-content-center align-items-center">
                                                                    <Bookmark className='bookMark' style={notice.bookmarkStatus == 'true' ? styles.bookMarkStatusCheck : styles.bookMarkStatusUncheck} onClick={() => bookmarkNotice(notice.noticeId, notice.bookmarkStatus)} />
                                                                </div>
                                                                <div className="d-flex justify-content-center align-items-center">
                                                                    {
                                                                        notice.readStatus == "true" ?
                                                                            <DoneAllIcon style={notice.readStatus ? styles.unreadNoticeChecked : styles.unreadNoticeUnchecked} />
                                                                            :
                                                                            <CheckOutlined style={notice.readStatus ? styles.unreadNoticeUnchecked : styles.unreadNoticeUnchecked} />
                                                                    }
                                                                </div>
                                                            </div>
                                                        );
                                                    })
                                                :
                                                    filterApplied ? 
                                                        <div style={ { marginLeft: 14 } }>No notice details found as per applied filter.</div>
                                                    :
                                                        <div style={ { marginLeft: 14 } }>No notice yet assigned. Please contact administrator for more details.</div>
                                        }
                                    </div>
                            }
                        </>
                }
                <div>
                    {
                        totalCount > 20 &&
                        <p style={{ textAlign: "right", opacity: Object.keys(noticeList).length == totalCount ? 0.5 : 1, color: '#0465AC', marginRight: "10px", cursor: "pointer" }} onClick={(e) => Object.keys(noticeList).length == totalCount ? e.preventDefault() : getNoticeListLoadMore()}>Load More</p>
                    }
                </div>
                <div className='divPadding' />
            </div>
            {/* modal for read/unread status */}
            {showModalReadUnreadStatus && <div>
                <div className="modal fade show" id="modalContainer"  >
                    <div className="modal-dialog modal-dialog-centered modal-xl" style={{ height: '90%' }} >
                        <div className="h-100 modal-content">

                            <div className="modal-header d-flex text-center p-2" style={{ backgroundColor: '#0465ac' }} >
                                <div className=" flex-grow-1">
                                    <p className="modal-title text-white">{!showModalHistory ? 'Read/Unread Status' : 'Notification History'}</p>
                                </div>
                                <div className="">
                                    <Close style={{ color: 'white', cursor: 'pointer' }} onClick={() => {
                                        setShowModalReadUnreadStatus(false);
                                    }} />
                                </div>
                            </div>

                            <div className="bg-white h-100 bodyBackgroundColor scrollController" style={{ overflow: 'auto' }}>

                                {showModalHistory === false ? <div>
                                    <div className='d-flex align-items-end flex-wrap px-2' style={{ gap: '15px', height: '10%' }}>
                                        <div style={{ width: "200px" }}>
                                            <input className='smallFont rounded' style={{ padding: '3px', border: '0.2px solid #BDBDBD' }} value="" placeholder='Search By Title...' />
                                        </div>
                                        <div className=' h-100' style={{ width: "200px" }}>
                                            <div className='d-flex flex-column justify-content-between h-100'>
                                                <div className='smallFont'>Date</div>
                                                <input

                                                    type="date" style={{ padding: '3px', border: '0.2px solid #BDBDBD' }} className='rounded smallFont secondaryColor' />
                                            </div>
                                        </div>
                                        <div className=' h-100' style={{ width: "200px" }}>
                                            <div className='d-flex flex-column justify-content-between h-100'>
                                                <div className='smallFont'>Role</div>
                                                <select className='rounded py-1 w-100 inputBox bg-white smallFont secondaryColor'>
                                                    <option>Student</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div style={{ width: "130px" }}>
                                            <div className="form-check primaryColor">
                                                <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
                                                <span className='smallFont'>Notify again</span>
                                            </div>
                                        </div>
                                        <div style={{ width: "220px" }}>
                                            <div onClick={() => setShowModalHistory(true)} className='smallBoldFont primaryColor pointer'><History className='mx-2' />View Notification  History</div>
                                        </div>
                                    </div>
                                    <div className='p-2'>
                                        <table className="table table-sm table-bordered">
                                            <thead >
                                                <tr className='secondaryColor' >
                                                    <th className='text-center' scope="col">Sr. No.</th>
                                                    <th className='text-center' scope="col">Name</th>
                                                    <th className='text-center' scope="col">Role</th>
                                                    <th className='text-center' scope="col">Read Date</th>
                                                    <th className='text-center' scope="col">Read Time</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr className='smallFont secondaryColor'>
                                                    <td>1</td>
                                                    <td className='text-center'>1</td>
                                                    <td className='text-center'>1</td>
                                                    <td className='text-center'>1</td>
                                                    <td className='text-center'>1</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                </div> :
                                    <div className='col-12 h-100'>
                                        <div className='pointer primaryColor d-flex align-items-center' style={{ height: '8%' }}>
                                            <ArrowBack onClick={() => setShowModalHistory(false)} />
                                        </div>
                                        <div className='p-2'>
                                            <table className="table table-sm table-bordered">
                                                <thead >
                                                    <tr className='secondaryColor' >
                                                        <th className='text-center' scope="col">Sr. No.</th>
                                                        <th className='text-center' scope="col">Name</th>
                                                        <th className='text-center' scope="col">Role</th>
                                                        <th className='text-center' scope="col">Read Date</th>
                                                        <th className='text-center' scope="col">Read Time</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr className='smallFont secondaryColor'>
                                                        <td>1</td>
                                                        <td className='text-center'>1</td>
                                                        <td className='text-center'>1</td>
                                                        <td className='text-center'>1</td>
                                                        <td className='text-center'>1</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                }

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            }

            {/* modal for share */}
            {
                showShareModal && <div>
                    <div className="modal fade show" id="modalContainer"  >
                        <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content">

                                <div className="modal-header d-flex text-center p-2" style={{ backgroundColor: '#0465ac' }} >
                                    <div className=" flex-grow-1">
                                        <p className="modal-title text-white">Share To</p>
                                    </div>
                                    <div className="">
                                        <Close style={{ color: 'white', cursor: 'pointer' }} onClick={() => {
                                            setShowShareModal(false);
                                        }} />
                                    </div>
                                </div>

                                <div className="modal-body">
                                    <div className='smallFont'>Share this link via</div>
                                    <div className='d-flex justify-content-between align-items-center'>
                                        <div className="p-3 border border-primary " style={{ borderRadius: '50px' }}>
                                            <FacebookOutlined />
                                        </div>
                                        <div className="p-3 border border-primary " style={{ borderRadius: '50px' }}>
                                            <Twitter />
                                        </div>
                                        <div className="p-3 border border-primary " style={{ borderRadius: '50px' }}>
                                            <Instagram />
                                        </div>
                                        <div className="p-3 border border-primary " style={{ borderRadius: '50px' }}>
                                            <WhatsAppIcon />
                                        </div>
                                        <div className="p-3 border border-primary " style={{ borderRadius: '50px' }}>
                                            <Telegram />
                                        </div>
                                    </div>
                                    <div className='smallFont my-2'>Or Copy Link</div>
                                    <div className='d-flex border'>
                                        <div className='d-flex w-75 flex-grow-1 align-items-center'>
                                            <LinkOutlined className='mx-2' />
                                            <div className='smallFont secondaryColor text-truncate'>https://www.figma.com/proto/d5bq3aZ3zIEejFH6GSWyEn/Notice-Board?node-id=535%3A3478&starting-point-node-id=31%3A595&scaling=scale-down-width</div>
                                        </div>
                                        <button type="button" className="m-1 py-1 smallFont shadow-none btn btn-primary">copy</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }

            {/* sidebar for Notice View */}
            {
                showSideBarNoticeView &&
                <StudentNoticeView
                    noticeViewObject={getIndividualNoticeDetails}
                    setGetIndividualNoticeDetails={setGetIndividualNoticeDetails}
                    setShowSideBarNoticeView={setShowSideBarNoticeView}
                    fetchNoticeView={dataFetchingGetIndividualNoticeDetails}
                />
            }

            {/* SUCCESS MODAL FOR NOTICE BOARD DASHBOARD  */}
            {
                successModalDetails.successModal &&
                <SuccessModal
                    successModal={successModalDetails.successModal}
                    successModalType={successModalDetails.successModalType}
                    successMessage={successModalDetails.successMessage}
                    closeSuccessModal={closeSuccessModal}
                />
            }

            {/* RENDER TOAST CONTAINER FOR ADD BOOKMARK  */}
            {
                // <ToastContainer />
            }
        </>
    )
}

export default StudentNoticeDashboard;
